import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state:{
        user: Object,
        api: String,
        contactInfo: Array
    },
    mutations:{
        change(state,user){
            state.user = user
        },
        changeAPI(state, api){
            state.api = api
        },
        changeContactInfo(state, info){
            state.contactInfo = info;
        },
        addPayment(state, payment){
            state.user.payments.push(payment)
        }
    },
    getters:{
        user: state => state.user,
        api: state => state.api,
        contact: state => state.contactInfo
    }
})